import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { motion, AnimatePresence } from 'framer-motion';

// Placeholder functions (same as original)
const getLabel = (en, mr) => en;
const hasAccess = (path) => true;
const hasAccessToDropdown = (paths) => paths.some(hasAccess);

// Menu items array (same as original)

// Menu items array embedded in the component
const menuItems = [
  {
    label: getLabel("Home", "होम"),
    path: "/home",
    access: hasAccess("/home"),
  },
  {
    label: getLabel("Student", "विद्यार्थी"),
    path: "/student-register",
    access: hasAccessToDropdown([
      "/student-register",
      "/rollNo",
      "/all-student-report",
      "/leaving-certificate",
      "/bonafide",
      "/caste-report",
      "/minority-report",
      "/agewisereport",
      "/IdCard",
      "/generalregister",
      "/stdpersonaldata",
      "/importexport",
      "/admission-details",
      "/nirgam",
      "/outwordReg",
      "/certificates",
      "/distribution",
      "/shifaras-form",
      "/form-15a",
      "/promote",
    ]),
    children: [
      {
        label: getLabel("New students", "नवीन विद्यार्थी"),
        path: "/student-register",
        access: hasAccess("/student-register"),
      },
      {
        label: getLabel("Admission Forms", "प्रवेश फॉर्म"),
        path: "/admission-details",
        access: hasAccess("/admission-details"),
      },
      {
        label: getLabel("Roll Number", "हजेरी क्रमांक"),
        path: "/rollNo",
        access: hasAccess("/rollNo"),
      },
      {
        label: getLabel("Student Report", "विद्यार्थी अहवाल"),
        path: "/all-student-report",
        access: hasAccess("/all-student-report"),
      },
      {
        label: getLabel("Leaving Certificate", "शाळा सोडल्याचा दाखला"),
        path: "/leaving-certificate",
        access: hasAccess("/leaving-certificate"),
      },
      {
        label: getLabel("Bonafide", "बोनाफाईड"),
        path: "/bonafide",
        access: hasAccess("/bonafide"),
      },
      {
        label: getLabel("Nirgam Report", "निर्गम उतारा"),
        path: "/nirgam",
        access: hasAccess("/nirgam"),
      },
      {
        label: getLabel("Outward Report", "जावक उतारा"),
        path: "/outwordReg",
        access: hasAccess("/outwordReg"),
      },
      {
        label: getLabel("Caste Report", "जात अहवाल"),
        path: "/caste-report",
        access: hasAccess("/caste-report"),
      },
      {
        label: getLabel("Minority Report", "अल्पसंख्याक अहवाल"),
        path: "/minority-report",
        access: hasAccess("/minority-report"),
      },
      {
        label: getLabel("Age Report", "वय अहवाल"),
        path: "/agewisereport",
        access: hasAccess("/agewisereport"),
      },
      {
        label: getLabel("IdCard", "ओळखपत्र"),
        path: "/IdCard",
        access: hasAccess("/IdCard"),
      },
      {
        label: getLabel("General Register 1", "जनरल रजि.1"),
        path: "/generalregister",
        access: hasAccess("/generalregister"),
      },
      {
        label: getLabel("Height/Weight", "वजन/ऊंची"),
        path: "/stdpersonaldata",
        access: hasAccess("/stdpersonaldata"),
      },
      {
        label: getLabel("certificate", "प्रमाणपत्र"),
        path: "/certificates",
        access: hasAccess("/certificates"),
      },
      {
        label: getLabel("Import/Export", "आयात/निर्यात"),
        path: "/importexport",
        access: hasAccess("/importexport"),
      },
      {
        label: getLabel("School Supplies", "शालेय साहित्य"),
        path: "/distribution",
        access: hasAccess("/distribution"),
      },
      {
        label: getLabel("Shifaras Form", "शिफारस फॉर्म"),
        path: "/shifaras-form",
        access: hasAccess("/shifaras-form"),
      },
      {
        label: getLabel("Form 15A", "फॉर्म १५ए"),
        path: "/form-15a",
        access: hasAccess("/form-15a"),
      },
      {
        label: getLabel("Promote Students", "विद्यार्थी बढती"),
        path: "/promote",
        access: hasAccess("/promote"),
      },
    ],
  },
  {
    label: getLabel("Attendance", "हजेरी"),
    path: "/PresentySheet",
    access: hasAccessToDropdown(["/PresentySheet", "/PresentyReport"]),
    children: [
      {
        label: getLabel("Take Attendance", "हजेरी घ्या"),
        path: "/PresentySheet",
        access: hasAccess("/PresentySheet"),
      },
      {
        label: getLabel("Catalogue", "कॅटलॉग"),
        path: "/PresentyReport",
        access: hasAccess("/PresentyReport"),
      },
    ],
  },
  {
    label: getLabel("Account", "किर्द"),
    path: "/kird",
    access: hasAccessToDropdown(["/kird"]),
    children: [
      {
        label: getLabel("Account", "किर्द"),
        path: "/kird",
        access: hasAccess("/kird"),
      },
    ],
  },
  {
    label: getLabel("Fee", "फी"),
    path: "/atm1",
    access: hasAccessToDropdown(["/atm1", "/pavati"]),
    children: [
      {
        label: getLabel("Add Fee", "फी भरा"),
        path: "/atm1",
        access: hasAccess("/atm1"),
      },
      {
        label: getLabel("Fee Reports", "फी रिपोर्ट"),
        path: "/pavati",
        access: hasAccess("/pavati"),
      },
    ],
  },
  {
    label: getLabel("MDM", "पोषण आहार"),
    path: "/praman",
    access: hasAccessToDropdown([
      "/dainandin",
      "/sadhyachasatha",
      "/aavaksatha",
      "/menu",
      "/magani",
      "/praman",
      "/eggandbananaReport",
      "/chavreport",
      "/BMIReport",
      "/certificate",
    ]),
    children: [
      {
        label: getLabel("Quantity", "आहार प्रमाण"),
        path: "/praman",
        access: hasAccess("/praman"),
      },
      {
        label: getLabel("Menu", "आहार मेनू"),
        path: "/menu",
        access: hasAccess("/menu"),
      },
      {
        label: getLabel("incoming entry", "आवक नोंद"),
        path: "/aavaksatha",
        access: hasAccess("/aavaksatha"),
      },
      {
        label: getLabel("Daily register", "दैनंदिन नोंदवही"),
        path: "/dainandin",
        access: hasAccess("/dainandin"),
      },
      {
        label: getLabel("Current stock", "सध्याचा साठा"),
        path: "/sadhyachasatha",
        access: hasAccess("/sadhyachasatha"),
      },
      {
        label: getLabel("Demand", "मागणी"),
        path: "/magani",
        access: hasAccess("/magani"),
      },
      {
        label: getLabel("Egg/Banana Report", "अंडी/केळी अहवाल"),
        path: "/eggandbananaReport",
        access: hasAccess("/eggandbananaReport"),
      },
      {
        label: getLabel("Taste Report", "चव अहवाल"),
        path: "/chavreport",
        access: hasAccess("/chavreport"),
      },
      {
        label: getLabel("BMI Report", "BMI Report"),
        path: "/BMIReport",
        access: hasAccess("/BMIReport"),
      },
      {
        label: getLabel("Certificate", "प्रमाणपत्र"),
        path: "/certificate",
        access: hasAccess("/certificate"),
      },
    ],
  },
  {
    label: getLabel("Result", "निकालपत्र"),
    path: "/GunaNeendani",
    access: hasAccessToDropdown([
      "/GunaNeendani",
      "/resulthsc",
      "/resultssc",
      "/prgReportwd",
      "/progresssheet",
      "/collectout",
      "/subjectwise",
      "/gradewise",
      "/dailyregister",
      "/boardresult",
      "/Icse",
      "/promote",
    ]),
    children: [
      {
        label: getLabel("Mark Registration", "गुण नोंदणी"),
        path: "/GunaNeendani",
        access: hasAccess("/GunaNeendani"),
      },
      {
        label: getLabel("Progress sheet", "प्रगती पत्रक"),
        path: "/progresssheet",
        access: hasAccess("/progresssheet"),
      },
      {
        label: getLabel("combined result", "एकत्रित निकाल"),
        path: "/collectout",
        access: hasAccess("/collectout"),
      },
      {
        label: getLabel("Subject wise results", "विषयनिहाय निकाल"),
        path: "/subjectwise",
        access: hasAccess("/subjectwise"),
      },
      {
        label: getLabel("Grade Wise Results", "श्रेणी निहाय निकाल"),
        path: "/gradewise",
        access: hasAccess("/gradewise"),
      },
      {
        label: getLabel("Daily register", "दैनंदिन नोंदवही"),
        path: "/dailyregister",
        access: hasAccess("/dailyregister"),
      },
      {
        label: getLabel("5th & 8th Result", "५वी आणि ८वी निकाल"),
        path: "/boardresult",
        access: hasAccess("/boardresult"),
      },
      {
        label: getLabel("SSC Result", "SSC निकाल"),
        path: "/resultssc",
        access: hasAccess("/resultssc"),
      },
      {
        label: getLabel("HSC Result", "HSC निकाल"),
        path: "/resulthsc",
        access: hasAccess("/resulthsc"),
      },
      {
        label: getLabel("View Report", "अहवाल पहा"),
        path: "/prgReportwd",
        access: hasAccess("/prgReportwd"),
      },
      {
        label: getLabel("Promote Students", "विद्यार्थी बढती"),
        path: "/promote",
        access: hasAccess("/promote"),
      },
    ],
  },
  {
    label: getLabel("ICSE Result", "ICSE निकाल"),
    path: "/IcseMarkRegisteration",
    access: hasAccessToDropdown([
      "/IcseMarkRegisteration",
      "/IcseResult",
      "/IcseSubjectWise",
      "/IcseGradeWise",
      "/prgReportwtd",
      "/promote",
      "/Icse",
    ]),
    children: [
      {
        label: getLabel("Mark Registeration", "ICSE निकाल"),
        path: "/IcseMarkRegisteration",
        access: hasAccess("/IcseMarkRegisteration"),
      },
      {
        label: getLabel("Icse Result", "प्रगती पत्रक"),
        path: "/IcseResult",
        access: hasAccess("/IcseResult"),
      },
      {
        label: getLabel("Subject wise results", "विषयनिहाय निकाल"),
        path: "/IcseSubjectWise",
        access: hasAccess("/IcseSubjectWise"),
      },
      {
        label: getLabel("Grade Wise Results", "श्रेणी निहाय निकाल"),
        path: "/IcseGradeWise",
        access: hasAccess("/IcseGradeWise"),
      },
      {
        label: getLabel("Prelims Result", "प्रगती पत्रक"),
        path: "/Icse",
        access: hasAccess("/Icse"),
      },
      {
        label: getLabel("View Report", "अहवाल पहा"),
        path: "/prgReportwtd",
        access: hasAccess("/prgReportwtd"),
      },
      {
        label: getLabel("Promote Students", "विद्यार्थी बढती"),
        path: "/promote",
        access: hasAccess("/promote"),
      },
    ],
  },
  {
    label: getLabel("CBSE Result", "CBSE निकाल"),
    path: "/cbsemarkentery",
    access: hasAccessToDropdown(["/cbsemarkentery", "/cbsehsresult", "/cbseresult", "/preprimary", "/cbsesubjectcwise", "/promote"]),
    children: [
      {
        label: getLabel("Mark Registeration", "गुण नोंदणी"),
        path: "/cbsemarkentery",
        access: hasAccess("/cbsemarkentery"),
      },
      {
        label: getLabel("High-school Result", "High-school Result"),
        path: "/cbsehsresult",
        access: hasAccess("/cbsehsresult"),
      },
      {
        label: getLabel("Primary Result", "Primary Result"),
        path: "/cbseresult",
        access: hasAccess("/cbseresult"),
      },
      {
        label: getLabel("Pre-Primary Result", "Pre-Primary Result"),
        path: "/preprimary",
        access: hasAccess("/preprimary"),
      },
      {
        label: getLabel("Subject Wise Result", "Subject Wise Result"),
        path: "/cbsesubjectcwise",
        access: hasAccess("/cbsesubjectcwise"),
      },
      {
        label: getLabel("Promote Students", "विद्यार्थी बढती"),
        path: "/promote",
        access: hasAccess("/promote"),
      },
    ],
  },
  {
    label: getLabel("Payroll", "कर्मचारी"),
    path: "/addteacher",
    access: hasAccessToDropdown(["/addteacher", "/dailyreport", "/viewattendance", "/TIdCard"]),
    children: [
      {
        label: getLabel("Add Staff", "कर्मचारी भरा"),
        path: "/addteacher",
        access: hasAccess("/addteacher"),
      },
      {
        label: getLabel("Staff Payroll", "कर्मचारी वेतन"),
        path: "/dailyreport",
        access: hasAccess("/dailyreport", "/viewattendance"),
      },
      {
        label: getLabel("Id Card", "ओळखपत्र"),
        path: "/TIdCard",
        access: hasAccess("/TIdCard"),
      },
    ],
  },
  {
    label: getLabel("Exam", "परीक्षा"),
    path: "/teacherandqueform",
    access: hasAccessToDropdown(["/teacherandqueform", "/taketest", "/studentresult"]),
    children: [
      {
        label: getLabel("Create Test", "test तयार करा"),
        path: "/teacherandqueform",
        access: hasAccess("/teacherandqueform"),
      },
      {
        label: getLabel("Take Test", "test घ्या"),
        path: "/taketest",
        access: hasAccess("/taketest"),
      },
      {
        label: getLabel("Result", "निकाल"),
        path: "/studentresult",
        access: hasAccess("/studentresult"),
      },
    ],
  },
  {
    label: getLabel("Time Table", "वेळापत्रक"),
    path: "/addSubject",
    access: hasAccessToDropdown([
      "/addSubject",
      "/principleform",
      "/teachertimetable",
      "/timetableform",
      "/timetableform1",
      "/weekdayform",
      "/addteacher",
    ]),
    children: [
      {
        label: getLabel("Add Subject", "विषय जोडा"),
        path: "/addSubject",
        access: hasAccess("/addSubject"),
      },
      {
        label: getLabel("Add Teacher", "शिक्षक जोडा"),
        path: "/addteacher",
        access: hasAccess("/addteacher"),
      },
      {
        label: getLabel("Assign Class-Subject", "वर्ग-विषय नियुक्त करा"),
        path: "/timetableform",
        access: hasAccess("/timetableform"),
      },
      {
        label: getLabel("Assign Period", "तास नियुक्त करा"),
        path: "/weekdayform",
        access: hasAccess("/weekdayform"),
      },
      {
        label: getLabel("Class Timetable", "वर्गाचे वेळापत्रक"),
        path: "/timetableform1",
        access: hasAccess("/timetableform1"),
      },
      {
        label: getLabel("Teacher's TimeTable", "शिक्षकांचे वेळापत्रक"),
        path: "/teachertimetable",
        access: hasAccess("/teachertimetable"),
      },
      {
        label: getLabel("All TimeTable", "सर्व वेळापत्रक"),
        path: "/principleform",
        access: hasAccess("/principleform"),
      },
    ],
  },
  {
    label: getLabel("Inventory", "इन्व्हेंटरी"),
    path: "/instock",
    access: hasAccessToDropdown(["/instock", "/outstock", "/balancestock"]),
    children: [
      {
        label: getLabel("Stock Inward", "आवक साठा"),
        path: "/instock",
        access: hasAccess("/instock"),
      },
      {
        label: getLabel("Stock Outward", "जावक साठा"),
        path: "/outstock",
        access: hasAccess("/outstock"),
      },
      {
        label: getLabel("Current Stock", "सध्याचा साठा"),
        path: "/balancestock",
        access: hasAccess("/balancestock"),
      },
    ],
  },
  {
    label: getLabel("permission", "परवानगी"),
    path: "/permissionAccess",
    access: hasAccess("/permissionAccess"),
  },
  {
    label: getLabel("Refer & Earn", "Refer & Earn"),
    path: null,
    access: true,
  },
];

const DB_NAME = "SchoolManagementDB";
const OBJECT_STORE_NAME = "studentData";

const getAllStudentsFromDB = () => {
  return new Promise((resolve) => {
    const openRequest = indexedDB.open(DB_NAME);
    openRequest.onerror = () => resolve([]);
    openRequest.onsuccess = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(OBJECT_STORE_NAME)) return resolve([]);
      try {
        const transaction = db.transaction(OBJECT_STORE_NAME, "readonly");
        const objectStore = transaction.objectStore(OBJECT_STORE_NAME);
        const getAllRequest = objectStore.getAll();
        getAllRequest.onerror = () => resolve([]);
        getAllRequest.onsuccess = (e) => resolve(e.target.result || []);
      } catch (err) {
        resolve([]);
      }
    };
  });
};

const NavigationSearchBar = ({ language = "English", setStdData }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [students, setStudents] = useState([]);
  const searchContainerRef = useRef(null);

  useEffect(() => {
    if (isSearchOpen) {
      getAllStudentsFromDB().then((data) => setStudents(data));
    }
  }, [isSearchOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchContainerRef.current && !searchContainerRef.current.contains(event.target)) {
        setIsSearchOpen(false);
      }
    };
    if (isSearchOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSearchOpen]);

  // Memoized filtered menu items
  const filteredItems = useMemo(() => {
    if (!searchQuery.trim()) return [];
    
    return menuItems
      .filter((item) => {
        const mainMenuMatches =
          item.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (item.path && item.path.toLowerCase().includes(searchQuery.toLowerCase()));

        const submenuMatches = item.children?.some(
          (child) =>
            child.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (child.path && child.path.toLowerCase().includes(searchQuery.toLowerCase()))
        );

        return mainMenuMatches || submenuMatches;
      })
      .map((item) => {
        if (item.children) {
          return {
            ...item,
            children: item.children.filter(
              (child) =>
                child.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
                (child.path && child.path.toLowerCase().includes(searchQuery.toLowerCase()))
            )
          };
        }
        return item;
      })
      .filter((item) => item.access && (item.children ? item.children.length > 0 : true));
  }, [searchQuery]);

  // Filtered student results
  const filteredStudents = useMemo(() => {
    if (!searchQuery.trim()) return [];
    const query = searchQuery.toLowerCase();
    return students.filter((student) => {
      return (
        (student.stdName && student.stdName.toLowerCase().includes(query)) ||
        (student.stdFather && student.stdFather.toLowerCase().includes(query)) ||
        (student.stdSurname && student.stdSurname.toLowerCase().includes(query)) ||
        (student.stdAdharNo && student.stdAdharNo.toLowerCase().includes(query)) ||
        (student.registerNo && student.registerNo.toLowerCase().includes(query)) ||
        (student.currentClass && student.currentClass.toLowerCase().includes(query)) ||
        (student.mobileNo && student.mobileNo.toLowerCase().includes(query))
      );
    }).slice(0, 10);
  }, [searchQuery, students]);

  const toggleSearch = useCallback(() => {
    setIsSearchOpen(prev => !prev);
    if (isSearchOpen) {
      setSearchQuery("");
    }
  }, [isSearchOpen]);

  const handleItemClick = useCallback(() => {
    setIsSearchOpen(false);
    setSearchQuery("");
  }, []);

  const handleStudentClick = (student, index) => {
    setIsSearchOpen(false);
    setSearchQuery("");
    const fullName = `${student.stdName || ""} ${student.stdFather || ""} ${student.stdSurname || ""}`.trim();
    localStorage.setItem("selectedStudentSerialNo", student.serialNo || index + 1);
    localStorage.setItem("selectedStudentId", student.id);
    localStorage.setItem("selectedStudentName", fullName);
    if (typeof setStdData === "function") {
      setStdData(student);
    }
    window.location.reload();
  };

  return (
    <div style={{ position: 'relative' }} ref={searchContainerRef}>
      {/* Inline Search Bar Input (matching photo) */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#f8fafc',
          border: isFocused ? '1px solid #94a3b8' : '1px solid #e2e8f0',
          borderRadius: '8px',
          padding: '6px 14px',
          width: '380px',
          maxWidth: '80vw',
          transition: 'all 0.2s ease',
        }}
      >
        <SearchIcon style={{ color: '#94a3b8', fontSize: '1.2rem', marginRight: '10px' }} />
        <input
          type="text"
          placeholder={
            language === "English"
              ? "Search students, staff, classes, fee..."
              : "विद्यार्थी, कर्मचारी, वर्ग, फी ने शोधा..."
          }
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            if (!isSearchOpen) setIsSearchOpen(true);
          }}
          onFocus={() => {
            setIsFocused(true);
            setIsSearchOpen(true);
          }}
          onBlur={() => setIsFocused(false)}
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            fontSize: '13.5px',
            color: '#334155',
          }}
        />
        {searchQuery && (
          <button
            onClick={() => {
              setSearchQuery("");
              setIsSearchOpen(false);
            }}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '0 4px',
              color: '#94a3b8',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <CloseIcon style={{ fontSize: '1rem' }} />
          </button>
        )}
      </div>

      {/* Search Dropdown Results Panel */}
      <AnimatePresence>
        {isSearchOpen && searchQuery.trim() !== "" && (
          <motion.div
            initial={{ opacity: 0, y: 5, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 5, scale: 0.98 }}
            transition={{ duration: 0.15 }}
            style={{
              position: 'absolute',
              top: '46px',
              left: '0',
              width: 'min(90vw, 480px)',
              backgroundColor: '#ffffff',
              borderRadius: '12px',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.12)',
              zIndex: 9999,
              padding: '0',
              overflow: 'hidden',
              border: '1px solid #e2e8f0',
            }}
          >
            {/* Search Header */}
            <div style={{
              padding: '16px 20px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <SearchIcon style={{ marginRight: '10px', fontSize: '1.3rem' }} />
                <h4 style={{ margin: 0, fontWeight: 600, fontSize: '1.05rem' }}>
                  {language === "English" ? "Search VedGurukul" : "शोधा"}
                </h4>
              </div>
              <motion.button
                onClick={toggleSearch}
                style={{
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'white',
                  padding: '5px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                whileHover={{ backgroundColor: 'rgba(255, 255, 255, 0.3)' }}
                whileTap={{ scale: 0.9 }}
              >
                <CloseIcon style={{ fontSize: '1.1rem' }} />
              </motion.button>
            </div>

            {/* Search Input */}
            <div style={{ padding: '16px 20px 12px' }}>
              <motion.div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  border: isFocused ? '2px solid #667eea' : '1px solid #d1d5db',
                  backgroundColor: '#f9fafb',
                  transition: 'all 0.2s ease',
                }}
              >
                <SearchIcon style={{ marginLeft: '12px', color: '#9ca3af', fontSize: '1.2rem' }} />
                <input
                  type="text"
                  placeholder={
                    language === "English"
                      ? "Search students, staff, classes, fee..."
                      : "विद्यार्थी, कर्मचारी, वर्ग, फी ने शोधा..."
                  }
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  style={{
                    flex: 1,
                    padding: '12px 14px',
                    border: 'none',
                    outline: 'none',
                    fontSize: '14.5px',
                    backgroundColor: 'transparent',
                    color: '#1f2937',
                  }}
                  autoFocus
                />
                {searchQuery && (
                  <motion.button
                    onClick={() => setSearchQuery("")}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      padding: '0 12px',
                      color: '#6b7280',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <CloseIcon style={{ fontSize: '1rem' }} />
                  </motion.button>
                )}
              </motion.div>
            </div>

            {/* Search Results */}
            <motion.div
              style={{
                borderTop: '1px solid #f3f4f6',
              }}
            >
              <div
                style={{
                  maxHeight: '55vh',
                  overflowY: 'auto',
                  padding: '10px 20px 20px',
                }}
              >
                {searchQuery.trim() ? (
                  (filteredItems.length > 0 || filteredStudents.length > 0) ? (
                    <>
                      {/* Students Results Section */}
                      {filteredStudents.length > 0 && (
                        <div style={{ marginBottom: '16px' }}>
                          <div style={{
                            fontSize: '11px',
                            fontWeight: 700,
                            letterSpacing: '0.8px',
                            textTransform: 'uppercase',
                            color: '#6b7280',
                            marginBottom: '8px',
                            paddingLeft: '4px'
                          }}>
                            {language === "English" ? "Students" : "विद्यार्थी"} ({filteredStudents.length})
                          </div>
                          {filteredStudents.map((std, idx) => (
                            <motion.div
                              key={`std-${std.id || idx}`}
                              onClick={() => handleStudentClick(std, idx)}
                              style={{
                                padding: '10px 14px',
                                marginBottom: '6px',
                                borderRadius: '8px',
                                backgroundColor: '#f0f9ff',
                                borderLeft: '4px solid #0284c7',
                                cursor: 'pointer',
                                transition: 'all 0.15s ease',
                              }}
                              whileHover={{ backgroundColor: '#e0f2fe' }}
                            >
                              <div style={{ fontWeight: 600, color: '#0369a1', fontSize: '14px' }}>
                                {std.stdName} {std.stdFather} {std.stdSurname}
                              </div>
                              <div style={{ fontSize: '12px', color: '#475569', marginTop: '2px', display: 'flex', gap: '12px' }}>
                                {std.registerNo && <span>Reg: {std.registerNo}</span>}
                                {std.currentClass && <span>Class: {std.currentClass}</span>}
                                {std.mobileNo && <span>Mob: {std.mobileNo}</span>}
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      )}

                      {/* Menu Navigation Results Section */}
                      {filteredItems.length > 0 && (
                        <div>
                          <div style={{
                            fontSize: '11px',
                            fontWeight: 700,
                            letterSpacing: '0.8px',
                            textTransform: 'uppercase',
                            color: '#6b7280',
                            marginBottom: '8px',
                            paddingLeft: '4px'
                          }}>
                            {language === "English" ? "Navigation & Pages" : "नेव्हिगेशन"}
                          </div>
                          {filteredItems.map((item, index) => (
                            <div key={index} style={{ marginBottom: '10px' }}>
                              {item.path && (
                                <Link
                                  to={item.path}
                                  style={{
                                    display: 'block',
                                    padding: '10px 14px',
                                    color: '#4f46e5',
                                    fontWeight: '600',
                                    textDecoration: 'none',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    backgroundColor: '#eef2ff',
                                    borderLeft: '4px solid #6366f1',
                                  }}
                                  onClick={handleItemClick}
                                >
                                  {item.label}
                                </Link>
                              )}
                              {!item.path && item.label !== getLabel("Refer & Earn", "Refer & Earn") && (
                                <div
                                  style={{
                                    padding: '10px 14px',
                                    color: '#4f46e5',
                                    fontWeight: '600',
                                    fontSize: '14px',
                                    backgroundColor: '#eef2ff',
                                    borderRadius: '8px',
                                    borderLeft: '4px solid #6366f1',
                                  }}
                                >
                                  {item.label}
                                </div>
                              )}
                              {item.children?.length > 0 && (
                                <div style={{ marginLeft: '10px', marginTop: '6px' }}>
                                  {item.children.map((child, childIndex) => (
                                    child.access && child.path && (
                                      <Link
                                        key={childIndex}
                                        to={child.path}
                                        style={{
                                          display: 'block',
                                          padding: '8px 14px',
                                          color: '#374151',
                                          textDecoration: 'none',
                                          borderRadius: '6px',
                                          fontSize: '13.5px',
                                          marginBottom: '5px',
                                          backgroundColor: '#f9fafb',
                                          borderLeft: '3px solid #9ca3af',
                                        }}
                                        onClick={handleItemClick}
                                      >
                                        {child.label}
                                      </Link>
                                    )
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        padding: '30px 20px',
                        color: '#6b7280',
                        textAlign: 'center',
                        fontSize: '14px',
                      }}
                    >
                      <SearchIcon style={{ fontSize: '2.2rem', color: '#d1d5db', marginBottom: '10px' }} />
                      <div style={{ fontWeight: 500 }}>
                        {language === "English" ? "No results found" : "परिणाम सापडले नाही"}
                      </div>
                    </div>
                  )
                ) : (
                  <div
                    style={{
                      padding: '24px 20px',
                      color: '#6b7280',
                      textAlign: 'center',
                      fontSize: '13.5px',
                    }}
                  >
                    <SearchIcon style={{ 
                      fontSize: '2.2rem', 
                      color: '#d1d5db', 
                      marginBottom: '10px',
                    }} />
                    <div style={{ fontWeight: 500 }}>
                      {language === "English" 
                        ? "Search by student name, staff, class, fees or menu" 
                        : "विद्यार्थी, कर्मचारी, वर्ग किंवा फी ने शोधा"}
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NavigationSearchBar;

